import * as React from 'react';
import * as moment from "jalali-moment";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
// import {useLocation} from "react-router-dom";
import {setValidations} from "../../redux/public/actions";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";

export const convertPrice = (price) => {
  if (price && price != 'undefined') {
    const str = price?.toString()?.split(".");
    if (str[0]?.length >= 4) {
      str[0] = str[0]?.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    }
    if (str[1] && str[1]?.length >= 5) {
      str[1] = str[1]?.replace(/(\d{3})/g, "$1 ");
    }
    return str.join(".");
  }else{
    return 0
  }
}
export const convertDate = (date) => {
    return moment(date, 'YYYY/MM/DD').locale('fa').format('LL')
}
// export const convertTime = (time) => {
//   return moment(time, 'HH:MM:SS').locale('fa')
// }
export const addCommas = e => e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
export const removeNonNumeric = e => {
    const persianToEnglishMap = {
        '۰': '0',
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9'
    };
    // Use the mapping to convert each character
    const num = e.split('').map(char => persianToEnglishMap[char] || char).join('');
    return num.toString().replace(/[^\u06F0-\u06F90-9]/g, "")
};
export const removeNumeric = e => {
    var re = new RegExp(/[^\u0600-\u06FFA-Za-z]/g);
    if (re.test(e.toString())) {
        return e.toString().replace(re, "")
    } else {
        return e.toString()
    }
};
export const removeCommas = e => e.split(',').join('');
// export const convertI98ToZero = (e) => e.replace(/^\"98"/, "0");
export const normalizeText = (text) => text && text.replace(/آ/g, 'ا').toLowerCase();
export const checkNonZeroPrefix = (e) => {
    const regex = /^[\u06F0-\u06F91-9]{6}/; // عبارت منظم برای تطابق با 6 کاراکتر ابتدایی غیر از صفر
    return regex.test(e);
};
export const checkEmail = (e) => {
    let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;
    return regex.test(e);
};
// export const handleSetQuery = () => {
// const location = useLocation();
// // return searchParams.get('state') && searchParams.get('state') !== "null" &&  ({
// //   state: searchParams.get('state') || ""
// // }).toString()
// const setQuery = () => {
//   return location?.search
// }
//
// return {setQuery}
// }
export const handleScrollIntoView = (e) => {
    e.current?.scrollIntoView({behavior: 'smooth', block: "center", inline: "center"});
};
export const HandlerShowMessage = () => {
    const {t} = useTranslation()
    const {enqueueSnackbar} = useSnackbar()

    const showMessage = (e) => {
        switch (e) {
            case 200:
                return enqueueSnackbar(t("msg.t7"), {
                    variant: 'success',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            case 400:
                return enqueueSnackbar(t("msg.t9") + ' - ' + "400", {
                    variant: 'error',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            case 404:
                return enqueueSnackbar(t("msg.t8") + ' - ' + "404", {
                    variant: 'error',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            case 502:
                return enqueueSnackbar(t("msg.t9") + ' - ' + "502", {
                    variant: 'error',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            case 600:
                return enqueueSnackbar(t("msg.t10"), {
                    variant: 'error',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            case "ERR_NETWORK":
                return enqueueSnackbar(t("msg.t12"), {
                    variant: 'error',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            default:
                return null
        }
    }
    return {showMessage}
}
export const useShowMessageComponent = () => {
    const {enqueueSnackbar} = useSnackbar()

    let limit = 0

  const showMessageComponent = async (e, variant) => {
    if(limit < 1){
      if (e){
        await enqueueSnackbar(e, {
          variant: variant || 'success',
          TransitionProps: {
            direction: 'right',
          },
          anchorOrigin: {
            horizontal: 'left',
            vertical: 'top'
          },
          autoHideDuration: variant === "error" ? 5000 : 3000
        })
      }else{
        console.error('مشکلی رخ داده است')
      }
      limit++
    }
  }

    return {showMessageComponent}
}
// export const handleCheckNationalCode = (e) => {
//   return String(e)
//      .toLowerCase()
//      .match(/^[0-9]{10}$/);
// };
export const useOnlyEnglish = () => {
    const {showMessageComponent} = useShowMessageComponent()
    const {t} = useTranslation()
    const [errorShown, setErrorShown] = useState(false)

    const handleOnlyEnglish = (e) => {
        const re = new RegExp(/[^A-Za-z0-9!@#\$%\^\&*\s]/g)
        if (re.test(e.toString())) {
            if (!errorShown) {
                showMessageComponent(t("error.t60"), 'error')
                setErrorShown(true)
            }
            return e.toString().replace(re, "")
        } else {
            setErrorShown(false)
            return e.toString()
        }
    }

    return {handleOnlyEnglish}
}

export const handleSetServicesLogo = (e) => {
    switch (e) {
        case "Mail Express":
        case "Persia Mail Express":
            return require('../img/services/20.png')
        case "پستبار اکسپرس":
        case "پس کرایه پستبار اکسپرس":
            return require('../img/services/14.png')
        case "پست پیشتاز":
        case "پس کرایه پیشتاز":
            return require('../img/services/12.png')
        case "پیک هاب-تعارف":
        case "پیک هاب - توزیع":
        case "پیک هاب-لینک اکسپرس":
            return require('../img/services/15.png')
        case "sky post":
        case "Sky Post":
        case "سرویس اسکای پست":
        case "اسکای پست":
        case "اسکای پست-دیلی":
        case "اسکای پست دیلی":
            return require('../img/services/18.png')
        case "اسکای پست-بین المللی":
        case "اسکای پست بین المللی":
        case "اسکای پست  - بین المللی":
            return require('../img/services/26.png')
        case "راه آسمان آبی":
        case "BSW-راه آسمان آبی":
            return require('../img/services/6.png')
        case "پودو":
        case "سرویس پودو":
            return require('../img/services/16.png')
        case "چاپار":
        case "سرویس چاپار":
        case "اکسپرس-چاپار":
        case "سرویس اکسپرس-چاپار":
        case "اکسپرس-پرداخت توسط گیرنده-چاپار":
        case "سرویس اکسپرس-پرداخت توسط گیرنده-چاپار":
        case "پرداخت توسط گیرنده-چاپار":
        case "سرویس پرداخت توسط گیرنده-چاپار":
            return require('../img/services/9.png')
        case "حمل بار اوبار":
        case "سرویس حمل بار اوبار":
            return require('../img/services/12.png')
        case "ماهکس":
        case "بسته پس کرایه ماهکس":
            return require('../img/services/11.png')
        case "کالارسان - پست اتوبوسی":
        case "کالارسان اتوبوسی":
        case "کالارسان  اتوبوسی":
            return require('../img/services/7.png')
        case "اسنپ":
            return require('../img/services/1.png')
        case "اسپید":
            return require('../img/services/2.png')
        case "ارامکس":
            return require('../img/services/8.png')
        case "ppt":
            return require('../img/services/10.png')
        case "ندکس":
            return require('../img/services/13.png')
        case "گنجه":
            return require('../img/services/3.png')
        case "یارباکس":
            return require('../img/services/17.png')
        case "بیوپست":
            return require('../img/services/19.png')
        case "اسکای":
            return require('../img/services/18.png')
        case "pme":
            return require('../img/services/20.png')
        case "تعارف":
            return require('../img/services/21.png')
        case "تیپاکس":
        case "سرویس تیپاکس":
            return require('../img/services/22.png')
        case "جابار":
            return require('../img/services/23.png')
        case "تپسی":
            return require('../img/services/24.png')
        case "کالاپست":
        case "کالا پست":
            return require('../img/services/25.png')
        default:
            return require('../img/services/14.png')
    }
}
// export const handleReverseUnderline = (e) => {
//   const item = e?.split('_')
//   const final = item.reverse().join('_')
// }
export const handleCheckAddressWithState = (a, c, s) => !a.includes(c)
export const handleBorderColor = (e) => e && {border: '1px solid #FF3636'}
export const HandleValidationMethod = () => {
    const dispatch = useDispatch();
    const {showMessageComponent} = useShowMessageComponent()

    const validationMethod = (ref, key, message) => {
        dispatch(setValidations({[key]: message}))
        handleScrollIntoView(ref)
        showMessageComponent(message, 'error')
    }

    return {validationMethod}
}